import { render, staticRenderFns } from "./AlchemyResourceInfo.vue?vue&type=template&id=c49bf720&scoped=true"
import script from "./AlchemyResourceInfo.vue?vue&type=script&lang=js"
export * from "./AlchemyResourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49bf720",
  null
  
)

export default component.exports